import React from 'react'

function Header() {
    return (
        <h3>Expense Tracker</h3>
    )
}

export default Header